import { render } from "./TransactionRow.vue?vue&type=template&id=24210b20&scoped=true"
import script from "./TransactionRow.vue?vue&type=script&lang=js"
export * from "./TransactionRow.vue?vue&type=script&lang=js"

import "./TransactionRow.vue?vue&type=style&index=0&id=24210b20&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24210b20"]])

export default __exports__